"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _setmeal = require("@/api/iot/setmeal");
var _merchant = require("@/api/merchant");
var _batteryType = require("@/api/iot/batteryType");
var _default = {
  props: ['editItem'],
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      formData: {
        id: 0,
        merchant_id: '',
        gift_name: '',
        battery_type_id: '',
        price: '',
        lease_time: '',
        free_times: '',
        status: 1,
        coupon_id: '',
        coupon_num: 0,
        end_time: ''
      },
      merchantList: [],
      batteryTypeList: [
        // {
        //     id: 0,
        //     battery_type: '全部',
        // },
      ],
      couponList: [{
        id: 0,
        name: '无'
      }],
      defaultCouponList: [{
        id: 0,
        name: '无'
      }],
      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        gift_name: [{
          required: true,
          message: '请输入礼包名称',
          trigger: 'blur'
        }],
        battery_type_id: [{
          required: true,
          message: '请选择适用电池',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '价格必须大于0',
          trigger: 'blur'
        }],
        lease_time: [{
          required: true,
          message: '请输入换电有效期',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '换电有效期必须大于0',
          trigger: 'blur'
        }],
        free_times: [{
          required: true,
          message: '请输入换电次数',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '换电次数必须大于0',
          trigger: 'blur'
        }],
        end_time: [{
          required: true,
          message: '请选择礼包失效日期',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '优惠礼包';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            for (var key in _this.formData) {
              _this.formData[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    },
    'formData.merchant_id': function formDataMerchant_id(val) {
      console.log('formData.merchant_id', val);
      if (val) {
        this.defaultCouponList = this.$options.data().defaultCouponList;
        // this.formData.coupon_id = ''
        // this.formData.coupon_num = 0
        this.getSelectCouponList();
      }
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getBatteryTypeList();
  },
  methods: {
    reset: function reset() {
      this.formData = this.$options.data().formData;
      this.$refs['form'].resetFields();
    },
    remoteMethod: function remoteMethod() {
      var _this2 = this;
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.$func.debounce(function () {
        // console.log('remoteMethod', query)
        if (query === '') {
          _this2.couponList = (0, _toConsumableArray2.default)(_this2.defaultCouponList);
        } else {
          _this2.loading = true;
          _this2.getSelectCouponList(query);
        }
      });
    },
    getSelectCouponList: function () {
      var _getSelectCouponList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          param,
          res,
          _this$defaultCouponLi,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                param = {
                  name: search,
                  merchant_id: this.formData.merchant_id,
                  status: 1
                };
                _context.next = 4;
                return (0, _setmeal.getCouponList)(param).catch(function () {});
              case 4:
                res = _context.sent;
                // console.log('getSelectCouponList', res)
                this.loading = false;
                if (res.data) {
                  if (search == '') {
                    (_this$defaultCouponLi = this.defaultCouponList).push.apply(_this$defaultCouponLi, (0, _toConsumableArray2.default)(res.data));
                    this.couponList = (0, _toConsumableArray2.default)(this.defaultCouponList);
                  } else {
                    this.couponList = (0, _toConsumableArray2.default)(res.data);
                  }
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getSelectCouponList() {
        return _getSelectCouponList.apply(this, arguments);
      }
      return getSelectCouponList;
    }(),
    chkCouponId: function chkCouponId() {
      if (this.formData.coupon_id == 0) {
        this.formData.coupon_num = 0;
      }
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context2.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res, _this$batteryTypeList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _batteryType.batteryTypeList)();
              case 2:
                res = _context3.sent;
                if (res.data) {
                  (_this$batteryTypeList = this.batteryTypeList).push.apply(_this$batteryTypeList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this3 = this;
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$refs['form'].validate().catch(function (err) {});
              case 2:
                valid = _context4.sent;
                if (!valid) {
                  _context4.next = 10;
                  break;
                }
                if (!(this.formData.coupon_num > 0 && this.formData.coupon_cost_money <= 0)) {
                  _context4.next = 7;
                  break;
                }
                this.$func.isError('请输入 优惠券抵用金额');
                return _context4.abrupt("return");
              case 7:
                (0, _setmeal.editGift)({
                  form_data: this.formData
                }).then(function (res) {
                  _this3.dialogVisible = false;
                  _this3.$emit('getList');
                });
                _context4.next = 12;
                break;
              case 10:
                this.$message({
                  message: '请检查表单错误',
                  type: 'error'
                });
                return _context4.abrupt("return", false);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};
exports.default = _default;